const DataProtection = ({ datenschutzhinweise }) => {
  if (!datenschutzhinweise || !datenschutzhinweise.info) {
    return <p>Loading...</p>;
  }

  const { title, info } = datenschutzhinweise;

  return (
    <div className="legal-page container" style={{ padding: '100px 20px' }}>
      <h1>{title}</h1>
      <div>
        {info.split('\n').map((line, index) => (
          <p key={index}>{line}</p>
        ))}
      </div>
    </div>
  );
};

export default DataProtection;
